import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useCountries } from "melco-shared-logic";
import { CountryType } from "../../helper/commonHelper";
//import { useRolesContext } from "../../hooks/roles/useRolesContext";


type CountryListProps = {
  onChange: (value: CountryType[]) => void;
  value?: CountryType[];
};

export const AllCountrySelect: React.FC<CountryListProps> = ({
  value,
  onChange,
}) => {

  const { t } = useTranslation();
  const { countries } = useCountries();
  //const {roles} = useRolesContext();

  const countryList = (countries).map(
    (country) => ({
      value: country.code,
      label: country.name,
    })
  );


  //let countryAccessFilterListArray: string[] = [];

  //countryAccessFilterListArray = roles?.USERS_COUNTRY_ACCESS_LIST_FILTER_LIST?.toString()?.split(",") ?? [];

  //countryAccessFilterListArray = countryAccessFilterListArray.map((value)=>(value.trim()))
  // console.log(countryAccessFilterListArray)
  // const countryListOptions = countryList.filter((country)=>{

  //   if(roles.USERS_COUNTRY_ACCESS_LIST  && roles.USERS_COUNTRY_ACCESS_LIST_FILTER_LIST && roles.USERS_COUNTRY_ACCESS_LIST_FILTER_LIST != "") {
  //     if(country.value) {
  //       return  countryAccessFilterListArray.includes(country.value )
  //     }
  //   }
  //   else {
  //     return true
  //   }

  // })

  return (
    <Select
      mode="multiple"
      allowClear
      placeholder={t("global.label.country_code")}
      style={{ width: "100%" }}
      maxTagCount={1}
      options={countryList}
      onChange={onChange}
      value={value}
      showSearch
      optionFilterProp="label"
    />
  );
};
